import {
  Required,
  DataValidator,
  transformKeys,
  IsString,
  IsNumber,
  IsArray,
  IsBoolean,
  ValidateNested,
} from "@/utils/type-vaildator";
import api from "./api";

interface Response {
  broadcast: MaterialSettingsRange;
  broadcast_note: MaterialSettingsRange;
  mixcut: MaterialSettingsRange;
  mixcut_note: MaterialSettingsRange;
}

interface MaterialSettingsRange {
  public_enabled: boolean;
  personal_enabled: boolean;
  personal_configs: Array<PersonalConfigs>;
}

interface PersonalConfigs {
  folder_id: number;
  folder_name: string;
  selection_state: string;
  tags?: Tag[];
  total_tags: number;
};

interface Tag {
  tag_id: number;
  tag_name: string;
  is_selected: boolean;
}

export class TagData {
  @Required("tag id cannot be empty")
  @IsNumber("tag id must be a number")
  tagId: number;

  @Required("tag name cannot be empty")
  @IsString("tag name must be a string")
  tagName: string;

  @Required("is selected cannot be empty")
  @IsBoolean("is selected must be a boolean")
  isSelected: boolean;
}

export class PersonalConfigsData {
  @Required("folder id cannot be empty")
  @IsNumber("folder id must be a number")
  folderId: number;

  @Required("folder name cannot be empty")
  @IsString("folder name must be a string")
  folderName: string;

  @Required("selection state cannot be empty")
  @IsString("selection state must be a string")
  selectionState: string;

  // @Required("total tags cannot be empty")
  @IsNumber("total tags must be a number")
  selectTotal: number;

  @IsArray("tags must be an array")
  @Required("tags cannot be empty")
  tags: TagData[];
}

export class TemplateMaterialSettingsData {
  @Required("public enabled cannot be empty")
  @IsBoolean("public enabled must be a boolean")
  publicEnabled: boolean;

  @Required("personal enabled cannot be empty")
  @IsBoolean("personal enabled must be a boolean")
  personalEnabled: boolean;

  @Required("note enabled cannot be empty")
  @IsBoolean("note enabled must be a boolean")
  noteEnabled: boolean;

  @Required("personal configs cannot be empty")
  personalConfigs: PersonalConfigsData[];
}

export class AgentMaterialSettingsResponseData {
  @Required("broadcast cannot be empty")
  @ValidateNested(TemplateMaterialSettingsData)
  broadcast: TemplateMaterialSettingsData;

  @Required("mixcut cannot be empty")
  @ValidateNested(TemplateMaterialSettingsData)
  mixcut: TemplateMaterialSettingsData;

  @Required("broadcast note cannot be empty")
  @ValidateNested(TemplateMaterialSettingsData)
  broadcastNote: TemplateMaterialSettingsData;

  @Required("mixcut note cannot be empty")
  @ValidateNested(TemplateMaterialSettingsData)
  mixcutNote: TemplateMaterialSettingsData;
}

const transformAndValidateData = (
  response: Response
): AgentMaterialSettingsResponseData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AgentMaterialSettingsResponseData);
  } catch (error) {
    console.error("Agent material settings data validation failed:", error.message);
    throw error;
  }
};

/** 获取agent模板素材配置 */
export const agentMaterialSettings = async ({
  agentId,
  type,
}: { agentId: string, type: number }): Promise<AgentMaterialSettingsResponseData> => {
  const res = await api.get<Response>('/agent/material-settings', {
    agent_id: agentId,
    type,
  });
  const data = transformAndValidateData(res.data);
  return data;
}